import _ from "lodash";
import {isDefined} from "@/helper/Value";

export const REQUIRED = 'required';
export const STATISTIC = 'statistic';

export function isSet ()
{
	const data = getData();

	return isDefined(data);
}

export function hasConsent (key)
{
	const data = getData();

	return _.includes(data?.checkedCategories || [], key);
}

export function getData ()
{
	const asString = ('; ' + document.cookie).split(`; consent=`).pop().split(';')[0];

	return asString
		? JSON.parse(asString)
		: null;
}

export function setData (data)
{
	const now = new Date();

	now.setTime(
		now.getTime() + 60 * 60 * 24 * 365 * 1000 // 1 year
	);

	document.cookie = 'consent=' + JSON.stringify(data) + '; expires=' + now.toUTCString() + '; path=/'
}
